import { getContext } from '@fiverr-private/fiverr_context';
import { isRecommendedPackage } from '../../../../utils/packagesUtils';
import { BQ_CLICKED_PACKAGES_TAB } from '../../../../utils/bigQueryEvents';
import { customOrderPackage, TAB_NAMES } from '../config';
import { MP_CLICKED_TAB } from '../../../../utils/mixPanelEvents';

export const calcDefaultCheckedId = (packageList) => {
    let defaultCheckedId = 1;
    const { queryParameters } = getContext();
    packageList.forEach((packageData) => {
        if (isRecommendedPackage(packageData)) {
            defaultCheckedId = packageData.id;
        }
    });

    if (queryParameters.custom_package) {
        defaultCheckedId = customOrderPackage.id;
    }

    return defaultCheckedId;
};

export const reportTabClickEvents = (biEvents, tabId) => {
    reportTabClickBigQueryEvent(biEvents, tabId);
    reportTabClickMixpanelEvent(biEvents, tabId);
};

export const reportTabClickBigQueryEvent = (biEvents, tabId) => {
    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_PACKAGES_TAB,
        params: {
            page: {
                element: {
                    name: TAB_NAMES[tabId - 1],
                    position: tabId
                }
            }
        }
    });
};

export const reportTabClickMixpanelEvent = (biEvents, tabId) => {
    const eventName = MP_CLICKED_TAB;
    const params = {
        'Tab Name': TAB_NAMES[tabId - 1]
    };

    biEvents.sendMixPanelEvent({
        eventName,
        params
    });
};
